import { render, staticRenderFns } from "./ComNavBar.vue?vue&type=template&id=a0133136"
import script from "./ComNavBar.vue?vue&type=script&lang=js"
export * from "./ComNavBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports